import { SaneImage } from '@components/sanity/sane-image';
import { CtaCard } from '@components/common/cta-buttons';
import { PageProps } from '../../../types/page-props';

export function Hero(props: PageProps) {
  const { image } = props;

  return (
    <div className="overflow-hidden">
      <main className="lg:relative">
        <div className="mx-auto w-full max-w-7xl pt-16 pb-20 text-center lg:py-48 lg:text-left">
          <div className="px-4 sm:px-8 lg:w-1/2 xl:pr-16">
            <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl">
              <span>Email & SMS Passcodes</span>
            </h1>
            <p className="mx-auto mt-3 max-w-md text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
              Easily sign-up and verify an account in one-step with one-time
              passcodes. Or use them in your sign-in flow for a secure
              passwordless experience.
            </p>
            <CtaCard title={props.seo.title} />
          </div>
        </div>
        <div className="relative hidden h-64 w-full items-center bg-none sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:flex lg:h-full lg:w-1/2">
          <SaneImage
            src={image.invite}
            alt="OTP invite"
            className="mx-auto scale-75 rounded-lg shadow-xl"
          />
        </div>
      </main>
    </div>
  );
}
